import { render, staticRenderFns } from "./CircleJoin.vue?vue&type=template&id=477d38a8&scoped=true"
import script from "./CircleJoin.vue?vue&type=script&lang=js"
export * from "./CircleJoin.vue?vue&type=script&lang=js"
import style0 from "./CircleJoin.vue?vue&type=style&index=0&id=477d38a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d38a8",
  null
  
)

export default component.exports